import script from "./TimeSelector.vue?vue&type=script&lang=ts&setup=true"
export * from "./TimeSelector.vue?vue&type=script&lang=ts&setup=true"

import "./TimeSelector.vue?vue&type=style&index=0&id=ccfbcbba&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ccfbcbba"]])

export default __exports__